// Copyright (c) Move Closer 2022.

export const ARTICLE_HEADER_COMPONENT_KEY = 'ArticleHeaderComponent'

export interface ArticleHeaderConfig {
  displayDate: boolean
  displayShare: boolean
}

export const ARTICLE_HEADER_DEFAULT_CONFIG: ArticleHeaderConfig = {
  displayDate: true,
  displayShare: false
}
